import { isMobileOnly } from 'react-device-detect';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      columnGap: 1,
    },
    text: {
      fontWeight: 'inherit',
      fontSize: isMobileOnly ? 14 : 16,
      lineHeight: 1,
      textTransform: 'capitalize',
    },
  };
};
